/**
 * @generated SignedSource<<a0e28b59f2eaa66a8360f55eca07eeab>>
 * @relayHash 9c1433a098b8d67c1d47d21323cdafeb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 99dc6e26456dc3cca27a70a32c753eeb82bec6079452a0d1db666a1f8956e864

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type ContentDeleteActionType = "DELETE_DRAFT" | "DELETE_DRAFT_IF_BLANK" | "MOVE_TO_TRASH" | "PURGE_FROM_TRASH" | "%future added value";
export type DeleteDraftMutation$variables = {
  action: ContentDeleteActionType;
  contentId: string;
};
export type DeleteDraftMutation$data = {
  readonly deleteContent: {
    readonly contentId: string;
    readonly wasDeleted: boolean;
  } | null | undefined;
};
export type DeleteDraftMutation = {
  response: DeleteDraftMutation$data;
  variables: DeleteDraftMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "action"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "action",
        "variableName": "action"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      }
    ],
    "concreteType": "DeleteContentResponsePayload",
    "kind": "LinkedField",
    "name": "deleteContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "contentId"
      },
      {
        "kind": "ScalarField",
        "name": "wasDeleted"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "DeleteDraftMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DeleteDraftMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "9c1433a098b8d67c1d47d21323cdafeb",
    "id": "99dc6e26456dc3cca27a70a32c753eeb82bec6079452a0d1db666a1f8956e864",
    "metadata": {},
    "name": "DeleteDraftMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteDraftMutation($contentId:ID!,$action:ContentDeleteActionType!){deleteContent(contentId:$contentId,action:$action){contentId,wasDeleted}}"
  }
};
})();

(node as any).hash = "d5524f7ebeca5db81e74baaef5bc18f4";

export default node;
